export default __webpack_public_path__ + "static/media/icn-deposit-on.2a0338be.svg";